import React from 'react';
import SuccessNotificationBanner from '@components/SuccessNotificationBanner';
import { successMessageInMiddleOfSteps } from '@utils/commons';
import {
  ShowSuccessNotificationType,
  SuccessNotiPositionEnum,
} from '../../commons';

interface SaveAndContinueButtonProps {
  position: SuccessNotiPositionEnum;
  showSuccessNotification: ShowSuccessNotificationType;
  onSave: (
    e: React.MouseEvent<HTMLButtonElement>,
    position: SuccessNotiPositionEnum
  ) => void;
}

const SaveAndContinueButton: React.FC<SaveAndContinueButtonProps> = ({
  position,
  showSuccessNotification,
  onSave,
}) => {
  return (
    <>
      <div className="govuk-button-group">
        <button
          type="submit"
          className="govuk-button"
          data-module="govuk-button"
          disabled={showSuccessNotification.btnLoading}
          onClick={e => onSave(e, position)}
        >
          Save and continue
        </button>
      </div>

      {showSuccessNotification.status &&
        showSuccessNotification.position === position && (
          <div className="mt-10">
            <SuccessNotificationBanner
              title={successMessageInMiddleOfSteps.title}
              content={successMessageInMiddleOfSteps.content}
              duration={3000}
              noScrollToTop
            />
          </div>
        )}
    </>
  );
};

export default SaveAndContinueButton;
